import { render, staticRenderFns } from "./AgentAddressStep.vue?vue&type=template&id=4280aaf4&"
import script from "./AgentAddressStep.vue?vue&type=script&lang=js&"
export * from "./AgentAddressStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports